<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import ModalTrigger from "@/components/Interface/Modal/ModalTrigger.vue";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import PlayerName from '@/components/Objects/PlayerName.vue'

/**
 * Props
 */
const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.spy(64,props.newsItem.contentData.spy.imageCode)"
    :toast-text="'Cyber attack successful'"
  >
    <ModalTrigger type="spy" :data="{spyId: props.newsItem.contentData.spy.id}" >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="CDN.spy(512,props.newsItem.contentData.spy.imageCode)"
        :header="'Cyber attack successful'"
      >
        <div>
          <span class="text-slate-300">{{ props.newsItem.contentData.spy.name }}</span> successfully destroyed {{ props.newsItem.contentData.data.destroyed ?? 1 }} ship(s) from <PlayerName :player-id="props.newsItem.contentData.spy.targetPlayerId" />.
        </div>
      </NewsItemBaseStructure>
    </ModalTrigger>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>